import { Box, LinearProgress, Typography } from "@mui/material"
import { VisibilityOutlined } from "@mui-symbols-material/w300"
import type { ReactElement } from "react"
import React from "react"

import { Button } from "@/components/common/Button"
import type { Product } from "@/graphql/codegen/graphql"
import { AssociatedProductsTable } from "@/screens/ManageProducts/components/Instructions/components/tables/AssociatedProductsTable"

const ProductsArea = ({
  products,
  fetchingProducts,
  associatedProductIds,
  noProductsFoundMessage,
  showInactive,
  setShowInactive,
  selected,
  onProductSelection,
}: {
  products: Product[]
  fetchingProducts: boolean
  associatedProductIds: number[]
  noProductsFoundMessage: string
  showInactive: boolean
  setShowInactive: (value: ((prevState: boolean) => boolean) | boolean) => void
  selected: Record<string, boolean>
  onProductSelection?: (selected: Record<string, boolean>) => void
}): ReactElement => {
  const productsCount = products.length ?? 0
  const noProductsFound = productsCount === 0 && !fetchingProducts

  if (fetchingProducts) {
    return <LinearProgress className='sticky top-0 z-10' />
  }

  return (
    <Box>
      <Box className='mb-6 flex justify-between align-middle'>
        <Typography className='mt-2 inline-flex align-middle text-sm leading-6'>
          <Typography className='inline-flex font-semibold text-gray-800'>{productsCount} products found</Typography>,
          Select one from the existing
        </Typography>
        <Box>
          <Button
            appearance='text'
            className='pr-0 text-sm'
            startIcon={<VisibilityOutlined />}
            onClick={() => setShowInactive((prev) => !prev)}
          >
            {showInactive ? "Hide" : "Show"} Inactive Products
          </Button>
        </Box>
      </Box>
      {noProductsFound ? (
        <Box className='flex flex-col items-center justify-center'>
          <Typography className='text-gray-500'>{noProductsFoundMessage}</Typography>
        </Box>
      ) : (
        <Box className='max-h-[400px] overflow-auto'>
          <AssociatedProductsTable
            isSelectable={true}
            products={products}
            selected={selected}
            onProductSelection={onProductSelection}
            associatedProductIds={associatedProductIds}
          />
        </Box>
      )}
    </Box>
  )
}

export default ProductsArea
